/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetOrganizationUserSessionIssuerCimdClientSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetOrganizationUserSessionIssuerCimdClientRequest = {
  /**
   * The user_session_issuer_cimd_client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetOrganizationUserSessionIssuerCimdClientSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetOrganizationUserSessionIssuerCimdClientSecurity$outboundSchema:
  z.ZodMiniType<
    GetOrganizationUserSessionIssuerCimdClientSecurity$Outbound,
    GetOrganizationUserSessionIssuerCimdClientSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getOrganizationUserSessionIssuerCimdClientSecurityToJSON(
  getOrganizationUserSessionIssuerCimdClientSecurity:
    GetOrganizationUserSessionIssuerCimdClientSecurity,
): string {
  return JSON.stringify(
    GetOrganizationUserSessionIssuerCimdClientSecurity$outboundSchema.parse(
      getOrganizationUserSessionIssuerCimdClientSecurity,
    ),
  );
}

/** @internal */
export type GetOrganizationUserSessionIssuerCimdClientRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetOrganizationUserSessionIssuerCimdClientRequest$outboundSchema:
  z.ZodMiniType<
    GetOrganizationUserSessionIssuerCimdClientRequest$Outbound,
    GetOrganizationUserSessionIssuerCimdClientRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
      });
    }),
  );

export function getOrganizationUserSessionIssuerCimdClientRequestToJSON(
  getOrganizationUserSessionIssuerCimdClientRequest:
    GetOrganizationUserSessionIssuerCimdClientRequest,
): string {
  return JSON.stringify(
    GetOrganizationUserSessionIssuerCimdClientRequest$outboundSchema.parse(
      getOrganizationUserSessionIssuerCimdClientRequest,
    ),
  );
}
